import React from 'react';
import { Box, VStack, Text } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { surveyTheme as theme } from './surveyTheme';
import { t } from './translations';

const MotionBox = motion(Box);

/**
 * CompletionScreen - Thank you screen after survey submission
 *
 * Simple, warm, respectful. No confetti, no fanfare.
 * Just a clear confirmation that we received their response.
 *
 * Props:
 * - previewMode: boolean - If true, shows preview-specific messaging
 * - lang: 'en' | 'es'
 */
const CompletionScreen = ({ previewMode = false, lang = 'en' }) => {
  return (
    <Box
      minH="100vh"
      bg={theme.colors.background}
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={theme.spacing.screenPadding}
      pt={previewMode ? '40px' : 0}
    >
      <MotionBox
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
        textAlign="center"
        maxW="400px"
      >
        <VStack spacing={6}>
          {/* Checkmark */}
          <Box
            w={16}
            h={16}
            borderRadius="full"
            bg={theme.colors.teal}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CheckIcon boxSize={7} color="white" />
          </Box>

          {/* Message */}
          <VStack spacing={3}>
            <Text
              as="h1"
              fontSize={{ base: '26px', md: '30px' }}
              fontWeight={600}
              color={theme.colors.textPrimary}
              fontFamily={theme.typography.fontFamily}
            >
              {t(lang, 'thankYou')}
            </Text>
            <Text
              fontSize={theme.typography.body.fontSize}
              lineHeight={theme.typography.body.lineHeight}
              color={theme.colors.textSecondary}
              fontFamily={theme.typography.fontFamily}
            >
              {previewMode
                ? t(lang, 'previewComplete')
                : t(lang, 'responseRecorded')}
            </Text>
          </VStack>
        </VStack>
      </MotionBox>
    </Box>
  );
};

export default CompletionScreen;
